import React, { useEffect, useState } from "react";

import BreadCrumb from "../../common/breadcrumb";
import WelcomeWidget from "../../pages/dashboards/ecommerce/welcome-widget";
import OrderStatistics from "../../pages/dashboards/ecommerce/order-statistics";

import Widgets from "../../pages/dashboards/ecommerce/widgets";
import { useAppDispatch, useAppSelector } from "slices/hook";
import { AppDispatch } from "slices/store";
import { getCoreDataState } from "slices/core-data/reducer";
import { taxesGetThunk } from "slices/core-data/thunk";

import { DashboardSummaryResult } from "../../models/reports/dashboard-summary";
import { GetDashboardSummary } from "../../api/reports/index";
const AdminDashboard = () => {
  /*  const navigate = useNavigate();
    useEffect(() => navigate("/dashboard"), [navigate]); */
  const dispatch: AppDispatch = useAppDispatch();
  const { taxes } = useAppSelector(getCoreDataState);

  const [data, setData] = useState<DashboardSummaryResult | undefined>();

  useEffect(() => {
    const fetchData = async () => {
      dispatch(taxesGetThunk());
      loadReportData();
    };

    fetchData();
  }, []);

  const loadReportData = async () => {
    const res = await GetDashboardSummary();
    if (!(res?.status?.isError ?? false) && res?.data) {
      setData(res?.data ?? []);
    } else {
      setData({});
    }
  };

  return (
    <React.Fragment>
      <BreadCrumb title="Dashboards" pageTitle="Home" />
      <div className="grid grid-cols-12 gap-x-5">
        <WelcomeWidget />
        <div className="col-span-12 card">
          <OrderStatistics summary={data} />
        </div>

        <Widgets summary={data} />
        {/*  <SalesRevenue />
         <TrafficResources />
        <ProductsOrders />
        <CustomerService />
      <SalesMonth />
        <TopSellingProducts />
        <Audience /> */}
      </div>
    </React.Fragment>
  );
};

export default AdminDashboard;
